import { ThemeKeys } from '../components/DataProviders';

import light from './Light';
import dark from './Dark';
import peach from './Peach';
import unicorns from './Unicorns';




export interface CssPropsAndValues {
  [key: string]: string | undefined;
}

export interface Layout01ThemeCustomizations {
  card: CssPropsAndValues;
  cardHeader: CssPropsAndValues;
  recentTrackingDot: CssPropsAndValues;
}

export interface ThemeConfig {
  page: CssPropsAndValues;
  main: CssPropsAndValues;
  link: CssPropsAndValues;
  estimatedDeliveryDateOrStatus: CssPropsAndValues;
  signatureRequired: CssPropsAndValues;
  layoutSpecific: {
    layout01: Layout01ThemeCustomizations
  };
}

export function findTheme(themeKey: ThemeKeys) : ThemeConfig {
  switch( themeKey ) {
    case 'light':    return light;
    case 'dark':     return dark;
    case 'peach':    return peach;
    case 'unicorns': return unicorns;
    default:         return light;
  }
}

